import React, { useState, useEffect } from "react";
import {
  InputLabel, Select, MenuItem, FormControl,Button
} from "@mui/material";
import * as XLSX from "xlsx";
import {
   get_companies,  api_productExport,
    get_categories, get_sub_categories
 
} from "../services/product";
import CircularProgress from '@mui/material/CircularProgress';
import { useNavigate } from "react-router-dom";
import { IMG_BASE_URL, insertProductAttriCount, defaultSubCategory } from "../../../../constants";

const ProductImport = () => {
  const navigate = useNavigate();
   const [categories, setCategories] = useState([]);
    const [subCategories, setSubCategories] = useState([{
      "id": defaultSubCategory,
      name: "None"
    }]);
    const [companyId, setCompanyId] = useState("");
    const [categoryId, setCategoryId] = useState("");
    const [subCategoryId, setSubCategoryId] = useState("");
  const [companyname, setCompanyName] = useState("");
  const [categoryName, setCategoryName] = useState("");
  const [initialLoading, setInitialLoading] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [companyIdErrorMessage, setCompanyIdErrorMessage] = useState("");
  const [rows, setRows] = useState<any>([]);

  const fetch_companies = async () => {
    try {
      const response: any = await get_companies();
      setCompanies(response.data.data)
    } catch (error) {
    }
  }
  useEffect(() => {
    fetch_companies();
    fetch_categories();
  }, []);

    const fetch_categories = async () => {
      try {
        const response: any = await get_categories();
        setCategories(response.data.data)
      } catch (error) {
      }
    }
    const fetch_sub_categories = async (subCategoryId: number) => {
      try {
        const response: any = await get_sub_categories(subCategoryId);
        setSubCategories(response.data.data)
      } catch (error) {
      }
    }
  

  const productExportbyCompany = async () => {
    try{
       const data:any = await api_productExport(companyId,categoryId,subCategoryId);
       console.log("data", data);
         if (data && data?.data?.data && data?.data?.data.length > 0) {
          setRows(data?.data?.data);
          setInitialLoading(true);
          const ws = XLSX.utils.json_to_sheet(data?.data?.data);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, "Products");
          const fileName = `Products_${companyname}_${categoryName}.xlsx`;
          XLSX.writeFile(wb, fileName);
          setInitialLoading(false);
          setErrorMessage("");
         }else{
            setInitialLoading(false);
            setErrorMessage("No products found for the selected company, category, and sub-category.");
            return;
         }
    }catch(error:any){
        setInitialLoading(false);
        if (error && error.response && error.response.data && error.response.data.message) {
            setErrorMessage(error.response.data.message);
        } else {
            setErrorMessage("An error occurred while exporting products.");
        }
    }
  }
  const onChangeCategoryId = (e: any) => {
    setCategoryId(e.target.value)
    setSubCategoryId('');
    fetch_sub_categories(Number(e.target.value))
    const selectedCategory: any = categories.find((category: any) => category.id === e.target.value);
    setCategoryName(selectedCategory.name);
  }
  const onChangeSubCategoryId = (e: any) => {
    setSubCategoryId(e.target.value)
  }
  return (
    <div style={{
      backgroundColor: 'rgb(228 228 228)',
      padding: '20px'
    }}>
      <h4>Export Products

       </h4>
      <FormControl style={{ width: "150px", marginRight: "20px" }} size="small">
        <InputLabel>
          Company
        </InputLabel>
        <Select
          size="small"
          name="company"
          value={companyId}
          label="Company"
          onChange={(e) => {
            setCompanyId(e.target.value)
            const selectedCompany: any = companies.find((company: any) => company.id === e.target.value);
            setCompanyName(selectedCompany.name);
            setCompanyIdErrorMessage("");
          }}
        >
          {companies.map((e: any, indexG: any) => (
            <MenuItem value={e.id} key={"company" + indexG}>{e.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
       <FormControl style={{ width: "200px", marginRight: "10px" }} size="small">
              <InputLabel>
                Category <span style={{ color: 'red' }}>*</span>
              </InputLabel>
              <Select
                name="categoryId"
                label="Category *"
                value={categoryId}
                disabled={loading}
                onChange={onChangeCategoryId}
                fullWidth
              >{
                  categories && categories.length > 0 && (
                    categories.map((e: any, index: number) => {
                      return (
                        <MenuItem value={e.id} key={"category" + index}>{e.name}</MenuItem>
                      )
                    })
                  )
                }
              </Select>
            </FormControl>
            <FormControl style={{ width: "200px", marginRight: "10px" }} size="small">
              <InputLabel>
                Sub-Category <span style={{ color: 'red' }}>*</span>
              </InputLabel>
              <Select
                name="subCategoryId"
                label="Sub-Category *"
                disabled={loading}
                value={subCategoryId}
                onChange={onChangeSubCategoryId}
                fullWidth
              >
                {
                  subCategories && subCategories.length > 0 && (
                    subCategories.map((e: any, index: number) => {
                      return (
                        <MenuItem value={e.id} key={"subCategories" + index}>{e.name}</MenuItem>
                      )
                    })
                  )
                }
      
              </Select>
            </FormControl>
     
             <Button variant="contained" color="primary" onClick={()=>{
                                   productExportbyCompany();
                                }}  >
                                    Export
                                </Button>
     
     
      {companyIdErrorMessage && <><br />
        <label style={{ color: "red" }}>{companyIdErrorMessage}</label></>}
      {errorMessage && <><br />
        <label style={{ color: "red" }}>{errorMessage}</label></>}
      {
        initialLoading && <div><br />
          Loading data.... It will take 30 sec to 1 min so please don't refresh the page
        </div>
      }
      
    </div>
  );
};

export default ProductImport;
